function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_6086",
  "data-name": "Group 6086",
  transform: "translate(-151.855 -439)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Worker_3856238",
  transform: "translate(151.855 439)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3409",
  "data-name": "Path 3409",
  d: "M68.458,63.877C55.95,63.877,45.775,53.166,45.775,40H41c0,15.8,12.317,28.652,27.458,28.652S95.917,55.8,95.917,40H91.142C91.142,53.166,80.966,63.877,68.458,63.877Z",
  transform: "translate(-9.96 7.758)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3410",
  "data-name": "Path 3410",
  d: "M39.388,42.979H99.08a2.388,2.388,0,0,0,2.388-2.388V33.715a2.391,2.391,0,0,0-.758-1.745L98.8,30.19a27.284,27.284,0,0,0-15.735-24V5.069A5.319,5.319,0,0,0,77.541,0H60.928A5.323,5.323,0,0,0,55.4,5.073V6.205A27.3,27.3,0,0,0,39.665,30.188L37.758,31.97A2.391,2.391,0,0,0,37,33.715v6.876a2.388,2.388,0,0,0,2.388,2.388ZM69.234,19.1a2.388,2.388,0,1,1-2.388,2.388A2.388,2.388,0,0,1,69.234,19.1ZM41.775,34.752l1.9-1.774a2.389,2.389,0,0,0,.753-1.891A22.487,22.487,0,0,1,58.7,9.963a2.389,2.389,0,0,0,1.473-2.206l0-2.665a.881.881,0,0,1,.758-.316h5.918v9.968a7.163,7.163,0,1,0,4.775,0V4.776h5.919a.926.926,0,0,1,.753.293V7.747a2.388,2.388,0,0,0,1.473,2.206A22.25,22.25,0,0,1,94.039,31.085a2.388,2.388,0,0,0,.753,1.892l1.9,1.774V38.2H41.775Z",
  transform: "translate(-10.735 0.004)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3411",
  "data-name": "Path 3411",
  d: "M22.163,135.631a2.39,2.39,0,0,1-2.388-2.388V87.4c0-2.791,2.9-6.211,5.531-7.455l20.734-7.5V85.489h4.775s.027-14.622,0-14.765l4.043-1.479L66.6,85.489h5.89L57.675,64.99a2.392,2.392,0,0,0-2.748-.848L23.583,75.486q-.092.033-.18.073C19.272,77.448,15,82.391,15,87.4v45.848a7.171,7.171,0,0,0,7.163,7.163H35.949a14.259,14.259,0,0,1-2.871-4.775Z",
  transform: "translate(-15 12.411)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3412",
  "data-name": "Path 3412",
  d: "M113.932,75.559q-.088-.04-.18-.073L82.407,64.142a2.393,2.393,0,0,0-2.748.848l-14.812,20.5h5.89L82.476,69.245l4.087,1.479c-.027.142-.044,14.765-.044,14.765h4.775V72.437l20.734,7.5c2.628,1.244,5.531,4.664,5.531,7.455v45.848a2.391,2.391,0,0,1-2.388,2.388H104.256a14.259,14.259,0,0,1-2.871,4.775h13.786a7.171,7.171,0,0,0,7.163-7.163V87.4C122.334,82.391,118.062,77.448,113.932,75.559Z",
  transform: "translate(-5.337 12.411)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3413",
  "data-name": "Path 3413",
  d: "M112.38,88.546A7.243,7.243,0,0,0,106.74,86H35.226a7.023,7.023,0,0,0-7.073,8.587l6.538,33.871a9.73,9.73,0,0,0,9.293,7.684h54a9.73,9.73,0,0,0,9.293-7.684l6.538-33.871a7.267,7.267,0,0,0-1.433-6.042Zm-3.256,5.137-6.538,33.871a4.955,4.955,0,0,1-4.6,3.813h-54a4.955,4.955,0,0,1-4.6-3.813s-6.518-33.772-6.538-33.871a2.332,2.332,0,0,1,2.384-2.907H106.74a2.318,2.318,0,0,1,2.384,2.907Z",
  transform: "translate(-12.485 16.675)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_262",
  "data-name": "Ellipse 262",
  cx: 2.388,
  cy: 2.388,
  r: 2.388,
  transform: "translate(56.111 125.358)"
})), /*#__PURE__*/React.createElement("g", {
  id: "noun_tick_3923816",
  transform: "translate(367.091 518.777)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3432",
  "data-name": "Path 3432",
  d: "M19.5,2A17.5,17.5,0,1,0,37,19.5,17.5,17.5,0,0,0,19.5,2Zm9.933,14.415-10.5,9.625a1.75,1.75,0,0,1-2.42-.052l-5.25-5.25a1.75,1.75,0,1,1,2.475-2.475L17.8,22.328l9.265-8.493a1.75,1.75,0,1,1,2.366,2.58Z",
  transform: "translate(-47 -79.832)",
  fill: "#f37320"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_6084",
  "data-name": "Group 6084",
  transform: "translate(-314 -1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_5417",
  "data-name": "Rectangle 5417",
  transform: "translate(610 492)",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 102,
  rx: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1.5,
  y: 1.5,
  width: 87,
  height: 99,
  rx: 3.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3490",
  "data-name": "Path 3490",
  d: "M9693.379,17711.166h66.762",
  transform: "translate(-9071.76 -17202)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3491",
  "data-name": "Path 3491",
  d: "M9693.379,17711.166h66.762",
  transform: "translate(-9071.76 -17191)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3492",
  "data-name": "Path 3492",
  d: "M9693.379,17711.166h33.381",
  transform: "translate(-9071.76 -17170)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3493",
  "data-name": "Path 3493",
  d: "M9693.379,17711.166h33.381",
  transform: "translate(-9071.76 -17159)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3494",
  "data-name": "Path 3494",
  d: "M9693.379,17711.166h33.381",
  transform: "translate(-9071.76 -17148)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3495",
  "data-name": "Path 3495",
  d: "M9693.379,17711.166h33.381",
  transform: "translate(-9071.76 -17135.533)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  width: 46,
  height: 46,
  transform: "translate(652 536)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M-696.279,19.322l-9.973-9.96V37.134a1.445,1.445,0,0,1-1.444,1.444h-.009a1.445,1.445,0,0,1-1.444-1.444V9.362l-9.973,9.96a1.444,1.444,0,0,1-2.042,0h0a1.445,1.445,0,0,1,0-2.042l12.44-12.44a1.449,1.449,0,0,1,2.048,0l12.44,12.44a1.445,1.445,0,0,1,0,2.042h0A1.444,1.444,0,0,1-696.279,19.322Z",
  transform: "translate(1382.524 537.627)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3496",
  "data-name": "Path 3496",
  d: "M9693.379,17711.166h66.762",
  transform: "translate(-9071.76 -17180)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 3.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_6085",
  "data-name": "Group 6085",
  transform: "translate(-431 63.473)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3484",
  "data-name": "Path 3484",
  d: "M11487.514,19508.41l7.226,2.209v18.828l-7.226-7.756Z",
  transform: "translate(-10676 -19018)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_5699",
  "data-name": "Group 5699",
  transform: "translate(825.166 477.719)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Pencil_811378",
  transform: "translate(-21.836 9.698)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5698",
  "data-name": "Group 5698",
  transform: "translate(41.969 2.09) rotate(93)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3430",
  "data-name": "Path 3430",
  d: "M39.307,8.229h0L31.882.849,31.749.715a2.442,2.442,0,0,0-3.2-.222,2.876,2.876,0,0,0-.4.356l-24.54,24.5a2.621,2.621,0,0,0-.756,1.867h0c-.044.133-.133.267-.178.4L.051,37.659a2.535,2.535,0,0,0-.044.578,1.509,1.509,0,0,0,.445,1.2,1.592,1.592,0,0,0,1.111.489h.267a1.668,1.668,0,0,0,.445-.044l10.092-2.4a1.378,1.378,0,0,0,.578-.267,2.674,2.674,0,0,0,1.823-.756l24.54-24.54a2.589,2.589,0,0,0,.711-2.4A3.381,3.381,0,0,0,39.307,8.229ZM29.526,1.916a.669.669,0,0,1,.489-.178.714.714,0,0,1,.489.222l.133.133,7.38,7.38.044.044a.753.753,0,0,1,0,1.023l-3.423,3.423a.753.753,0,0,1-1.023,0L26.058,6.406a.649.649,0,0,1,0-.978Zm2.356,14.849a.753.753,0,0,1-1.023,0L23.3,9.207a.753.753,0,0,1,0-1.023l1.156-1.156a2.09,2.09,0,0,0,.4.533l7.558,7.558h0a2,2,0,0,0,.622.445ZM4.9,37.481l-2.356-2.4,1.467-5.646L10.676,36.1Zm8.625-2.267a.912.912,0,0,1-1.289,0l-7.38-7.38a.878.878,0,0,1-.267-.622.807.807,0,0,1,.267-.622l16.8-16.8a5.792,5.792,0,0,0,.445.667l7.558,7.558a1.759,1.759,0,0,0,.667.445Z",
  transform: "translate(0 0)",
  fill: "#f37320"
}))))));

function SvgStepper2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 262.444,
    height: 154,
    viewBox: "0 0 262.444 154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepper2);
export default __webpack_public_path__ + "static/media/stepper2.6a2c32e523a04770d41c86fd84e3f70a.svg";
export { ForwardRef as ReactComponent };